import { motion } from 'framer-motion';
import { ArrowLongRightIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

const timelineData = [
  {
    year: '2013',
    title: 'Launched School Feeding Program',
    link: '/programs#school-feeding'
  },
  {
    year: '2016',
    title: 'Girl-Child Education Study & School Eye Health Initiative',
    link: '/programs#girl-child-education'
  },
  {
    year: '2017',
    title: 'Monitoring of Learning Achievements',
    link: '/programs#learning-achievements'
  },
  {
    year: '2019',
    title: 'Capacity Development of Science Teachers',
    link: '/programs#capacity-development'
  },
  {
    year: '2023',
    title: 'Establishment of Goodwill Medical Centre',
    link: '/goodwill-medical'
  },
  {
    year: '2024',
    title: 'The Bridge Project & Traditional Birth Attendants Program',
    link: '/programs#bridge-project'
  },
  {
    year: '2026',
    title: '17th Annual NTD NGO Network Conference — Kigali, Rwanda',
    link: '/reports'
  }
];

function Timeline() {
  return (
    <div className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-3xl font-bold text-center text-pacieh-blue mb-12"
        >
          OUR JOURNEY
        </motion.h2>
        
        <div className="relative max-w-3xl mx-auto">
          {/* Timeline line */}
          <div className="absolute left-[4.5rem] top-0 bottom-0 w-0.5 bg-pacieh-green/20" />
          
          <div className="space-y-6">
            {timelineData.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="relative flex items-center gap-6"
              >
                {/* Year */}
                <div className="w-16 text-right">
                  <span className="font-bold text-pacieh-green">{item.year}</span>
                </div>

                {/* Dot */}
                <div className="relative z-10">
                  <motion.div
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1 }}
                    className="w-4 h-4 bg-pacieh-green rounded-full flex items-center justify-center"
                  >
                    <div className="w-2 h-2 bg-white rounded-full" />
                  </motion.div>
                </div>

                {/* Content */}
                <Link
                  to={item.link}
                  className="flex-1 group"
                >
                  <motion.div
                    whileHover={{ x: 5 }}
                    className="bg-white py-3 px-4 rounded-lg shadow-sm border border-pacieh-green/10 flex items-center justify-between"
                  >
                    <h4 className="font-medium text-pacieh-blue group-hover:text-pacieh-green transition-colors">
                      {item.title}
                    </h4>
                    <ArrowLongRightIcon className="h-5 w-5 text-pacieh-green opacity-0 group-hover:opacity-100 transition-opacity" />
                  </motion.div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Timeline; 